/**
 * MIRA Form Component
 * Wraps Shadcn Form with MIRA design system styles
 * Re-exports react-hook-form utilities with MIRA styling
 */

import React from 'react';
import {
  Form as ShadcnForm,
  FormField,
  FormItem as ShadcnFormItem,
  FormLabel as ShadcnFormLabel,
  FormControl,
  FormDescription as ShadcnFormDescription,
  FormMessage as ShadcnFormMessage,
  useFormField,
} from '@/components/ui/form';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/form.module.css';

// Form is actually FormProvider from react-hook-form
export const Form = ShadcnForm;

// Re-export FormField (Controller wrapper)
export { FormField, FormControl, useFormField };

export const FormItem = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnFormItem
        ref={ref}
        className={cn(styles.miraFormItem, className)}
        {...props}
      />
    );
  }
);

FormItem.displayName = 'MiraFormItem';

export const FormLabel = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnFormLabel
        ref={ref}
        className={cn(styles.miraFormLabel, className)}
        {...props}
      />
    );
  }
);

FormLabel.displayName = 'MiraFormLabel';

export const FormDescription = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnFormDescription
        ref={ref}
        className={cn(styles.miraFormDescription, className)}
        {...props}
      />
    );
  }
);

FormDescription.displayName = 'MiraFormDescription';

export const FormMessage = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnFormMessage
        ref={ref}
        className={cn(styles.miraFormMessage, className)}
        {...props}
      />
    );
  }
);

FormMessage.displayName = 'MiraFormMessage';
